<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <!--<b-row>-->
        <!--<b-col>-->
          <!--<div v-if="created" class="alert alert-success" role="status">{{ created.name }} {{$t('notifications.created')}}.</div>-->
          <!--<div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>-->
          <!--<div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>-->
          <!--<div v-if="error" class="alert alert-danger" role="alert">-->
            <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}-->
          <!--</div>-->
          <!--<div v-if="deleteError" class="alert alert-danger" role="alert">-->
            <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}-->
          <!--</div>-->
        <!--</b-col>-->
      <!--</b-row>-->
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXCMAgreementTypeList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-header">
              <h4 class="card-title">{{$t('views.excmagreementtypes.update.header')}} {{ item && item['title'] }}</h4>
            </div>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMAgreementTypeForm
                    v-if="item"
                    :handle-submit="onSendForm"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations"
                    :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMAgreementTypeForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMAgreementTypeForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMAgreementTypeUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmagreementtype/update/isLoading',
      error: 'excmagreementtype/update/error',
      deleteError: 'excmagreementtype/del/error',
      deleteLoading: 'excmagreementtype/del/isLoading',
      created: 'excmagreementtype/create/created',
      deleted: 'excmagreementtype/del/deleted',
      retrieved: 'excmagreementtype/update/retrieved',
      updated: 'excmagreementtype/update/updated',
      violations: 'excmagreementtype/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMAgreementTypeList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmagreementtype/create/reset',
      deleteItem: 'excmagreementtype/del/del',
      delReset: 'excmagreementtype/del/reset',
      retrieve: 'excmagreementtype/update/retrieve',
      updateReset: 'excmagreementtype/update/reset',
      update: 'excmagreementtype/update/update',
      updateRetrieved: 'excmagreementtype/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmagreementtype ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
